/** Arabic for maintenance: work orders and their report, inspections, alerts, the dashboard and its KPIs, and the document library. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  /* ── shared across the area ── */
  "{code} · maintenance": "{code} · الصيانة",
  "Requires {permission}": "يتطلب الصلاحية {permission}",
  "+ New Work Order": "+ أمر عمل جديد",
  "Any status": "أي حالة",
  "Refused: {reason}": "رُفض: {reason}",
  "{n}d": "{n} يوم",
  OFFLINE: "دون اتصال",
  Kind: "النوع",
  Scope: "النطاق",

  /* ── work-order catalogues (domain/workOrders.ts) ── */
  Corrective: "تصحيحية",
  Preventive: "وقائية",
  Predictive: "تنبؤية",
  Project: "مشروع",
  Inspection: "فحص",
  "Out of scope": "خارج النطاق",
  "Return to draft": "إعادة إلى المسودة",
  Approve: "اعتماد",
  Dispatch: "إرسال",
  "Start work": "بدء العمل",
  "Put on hold": "تعليق",
  Complete: "إكمال",
  Verify: "تحقق",

  /* ── work-order report (domain/workOrderReport.ts) ── */
  Opened: "تاريخ الفتح",
  "7 days": "7 أيام",
  "30 days": "30 يومًا",
  "90 days": "90 يومًا",
  "Year to date": "منذ بداية السنة",
  Breached: "مُخترَق",
  "At risk": "معرّض للخطر",
  "On track": "ضمن المسار",
  Met: "مُستوفى",
  Missed: "فائت",
  "No SLA": "دون SLA",
  "Priority, then oldest": "الأولوية، ثم الأقدم",
  "Newest opened": "الأحدث فتحًا",
  "Oldest opened": "الأقدم فتحًا",
  "Due soonest": "الأقرب استحقاقًا",
  "SLA deadline soonest": "الأقرب موعدًا نهائيًا لـ SLA",
  "Recently completed": "المكتملة مؤخرًا",
  "Longest running": "الأطول مدة",
  "breached by {span}": "تجاوز الموعد بـ {span}",
  "{span} left": "متبقٍ {span}",
  "{span} to spare": "قبل الموعد بـ {span}",
  "late by {span}": "متأخر بـ {span}",
  "Not classified": "غير مصنّف",
  "Open orders": "الأوامر المفتوحة",
  "Closed orders": "الأوامر المغلقة",
  "All orders": "جميع الأوامر",
  "{field} from {from} to {to}": "{field} من {from} إلى {to}",
  "{field} from {from}": "{field} من {from}",
  "{field} to {to}": "{field} حتى {to}",
  "Status: {status}": "الحالة: {status}",
  "Priority: {priority}": "الأولوية: {priority}",
  "Kind: {kind}": "النوع: {kind}",
  "Repair type: {type}": "نوع الإصلاح: {type}",
  "Discipline: {discipline}": "التخصص: {discipline}",
  "SLA: {sla}": "SLA: {sla}",
  "Overdue only": "المتأخرة فقط",
  "Search: “{q}”": "البحث: «{q}»",

  /* ── work orders list ── */
  "Any priority": "أي أولوية",
  "Any kind": "أي نوع",
  "Repair type": "نوع الإصلاح",
  "Any repair type": "أي نوع إصلاح",
  Discipline: "التخصص",
  "Any discipline": "أي تخصص",
  "SLA status": "حالة SLA",
  "Any SLA status": "أي حالة SLA",
  "Search number, title, asset, repair type, crew…": "ابحث بالرقم أو العنوان أو الأصل أو نوع الإصلاح أو الفريق…",
  "{n} of {total}": "{n} من {total}",
  "DATE RANGE": "النطاق الزمني",
  "Date to filter on": "التاريخ المعتمد للتصفية",
  From: "من",
  TO: "إلى",
  To: "إلى",
  "Clear dates": "مسح التواريخ",
  SORT: "الترتيب",
  Sort: "الترتيب",
  "Hide statistics": "إخفاء الإحصاءات",
  "Show statistics": "عرض الإحصاءات",
  "Generate report": "إنشاء تقرير",
  "Export CSV": "تصدير CSV",
  "Reset filters": "إعادة تعيين عوامل التصفية",
  "Statistics, report and export cover the {n} orders shown.":
    "تشمل الإحصاءات والتقرير والتصدير الأوامر المعروضة وعددها {n}.",
  "The platform returned only the first page of work orders. Narrow with a status.":
    "أعادت المنصة الصفحة الأولى فقط من أوامر العمل. ضيّق النتائج باختيار حالة.",
  "No work orders match.": "لا توجد أوامر عمل مطابقة.",
  "The platform lists none at {code}.": "لا تسرد المنصة أي أوامر في {code}.",
  Number: "الرقم",
  Pri: "الأولوية",
  Work: "العمل",
  SLA: "SLA",
  Crew: "الفريق",
  Age: "العمر",
  OVERDUE: "متأخر",
  unassigned: "غير مُسند",

  /* ── statistics ── */
  Orders: "الأوامر",
  "P1 open": "P1 مفتوحة",
  "{n} canceled": "{n} ملغاة",
  "Mean days to complete": "متوسط أيام الإنجاز",
  "over {n} completed": "من {n} مكتملة",
  "none completed": "لا شيء مكتمل",
  "Completed on time": "مكتملة في موعدها",
  "of {n} with a due date": "من {n} لها تاريخ استحقاق",
  "no completed order had a due date": "لم يكن لأي أمر مكتمل تاريخ استحقاق",
  "SLA compliance": "الالتزام بـ SLA",
  "{met} met of {n} completed with an SLA": "{met} مُستوفاة من {n} مكتملة لها SLA",
  "{n} of {total} have an SLA; none completed yet": "{n} من {total} لها SLA؛ لم يكتمل أيٌّ منها بعد",
  "SLA breached": "SLA مُخترَق",
  "open past the window · {n} more at risk": "مفتوحة بعد انقضاء المهلة · {n} أخرى معرّضة للخطر",
  "open past the window": "مفتوحة بعد انقضاء المهلة",
  "Actual cost": "التكلفة الفعلية",
  "{n} of {total} record a cost": "{n} من {total} تسجّل تكلفة",
  "Labour hours": "ساعات العمل",
  "{n} of {total} record hours": "{n} من {total} تسجّل ساعات",
  "By repair type": "حسب نوع الإصلاح",
  "By discipline": "حسب التخصص",
  "By SLA status": "حسب حالة SLA",
  "By status": "حسب الحالة",
  "By priority": "حسب الأولوية",
  "By kind": "حسب النوع",
  "SLA by priority": "SLA حسب الأولوية",
  "No order here has an SLA. Set one when raising an order, or on the order itself.":
    "لا يوجد هنا أمر له SLA. حدّده عند إنشاء الأمر، أو في الأمر نفسه.",
  "Orders with an SLA": "الأوامر التي لها SLA",
  "With SLA": "لها SLA",
  "Completed inside the window": "اكتملت ضمن المهلة",
  "Completed after the window": "اكتملت بعد المهلة",
  "Still open, past the window": "لا تزال مفتوحة بعد انقضاء المهلة",
  "Met over completed": "المُستوفاة من المكتملة",
  "No orders.": "لا توجد أوامر.",
  "{label}: {n} of {total} ({pct}%)": "{label}: {n} من {total} ({pct}%)",
  "{tip} — click to clear": "{tip} — انقر للمسح",
  "{tip} — click to filter": "{tip} — انقر للتصفية",

  /* ── raise a work order ── */
  "New Work Order": "أمر عمل جديد",
  "From alert:": "من التنبيه:",
  "SLA hours (optional)": "ساعات SLA (اختياري)",
  "e.g. 4, 24, 72": "مثال: 4، 24، 72",
  "The window from opening that this order must be completed within. Left blank, the order has no SLA and is reported as such.":
    "المهلة من فتح الأمر التي يجب إنجازه خلالها. إذا تُركت فارغة فلا SLA للأمر ويُبلَّغ عنه كذلك.",
  "From when it is raised. Blank means no SLA — reported as “No SLA”, never as met.":
    "تُحسب من وقت إنشائه. الفراغ يعني عدم وجود SLA — ويُبلَّغ عنه «دون SLA»، ولا يُعدّ مُستوفى أبدًا.",
  "Asset tag (optional)": "رمز الأصل (اختياري)",
  "Zone code (optional)": "رمز المنطقة (اختياري)",
  "e.g. {example}": "مثال: {example}",
  "Create as draft": "إنشاء كمسودة",

  /* ── work order report ── */
  "Work order report": "تقرير أوامر العمل",
  "Print / save as PDF": "طباعة / حفظ بصيغة PDF",
  "Back to work orders": "العودة إلى أوامر العمل",
  "Work orders — {code} · {name}": "أوامر العمل — {code} · {name}",
  "Work orders — {code} ": "أوامر العمل — {code} ",
  "Generated {when} by {name}": "أُنشئ في {when} بواسطة {name}",
  "{n} of {total} orders on the platform": "{n} من {total} أمرًا على المنصة",
  "The platform returned only the first page of work orders; this report covers that page.":
    "أعادت المنصة الصفحة الأولى فقط من أوامر العمل؛ يغطي هذا التقرير تلك الصفحة.",
  "No work orders match these filters.": "لا توجد أوامر عمل مطابقة لعوامل التصفية هذه.",

  /* ── one work order ── */
  "{code} · work order": "{code} · أمر عمل",
  "{code} · work order · {kind}": "{code} · أمر عمل · {kind}",
  "← All work orders": "← جميع أوامر العمل",
  "Raised from an alert — why did it fire?": "أُنشئ من تنبيه — لماذا انطلق؟",
  "Requested by": "طلبه",
  Position: "الموقع",
  Started: "تاريخ البدء",
  "{date} by {name}": "{date} بواسطة {name}",
  "{n} days": "{n} يوم",
  "the defects this order closes and the tasks it is broken into":
    "العيوب التي يغلقها هذا الأمر والمهام التي يتكون منها",
  History: "السجل",
  "the append-only transition log — who, when, from what, to what":
    "سجل الانتقالات غير القابل للتعديل — من، ومتى، ومن أي حالة، وإلى أي حالة",
  "Raised as {status}": "أُنشئ بحالة {status}",
  "by {name}": "بواسطة {name}",
  "Service level (SLA)": "مستوى الخدمة (SLA)",
  "the window from opening this order must be completed within": "المهلة من فتح هذا الأمر التي يجب إنجازه خلالها",
  Window: "المهلة",
  Deadline: "الموعد النهائي",
  "Against it": "مقارنة بها",
  "New window, hours": "مهلة جديدة، بالساعات",
  "Window, hours": "المهلة، بالساعات",
  "SLA hours": "ساعات SLA",
  "Reason (recorded)": "السبب (يُسجَّل)",
  "Reason for the SLA": "سبب SLA",
  "Change SLA": "تغيير SLA",
  "Set SLA": "تحديد SLA",
  "Refused by the sample: {reason}": "رفضته البيانات التجريبية: {reason}",
  "Refused by the platform: {reason}": "رفضته المنصة: {reason}",
  "{status} — the SLA is part of the outcome now and cannot be changed.":
    "{status} — أصبح SLA جزءًا من النتيجة ولا يمكن تغييره.",
  Lifecycle: "دورة الحياة",
  "Move this work order": "نقل أمر العمل هذا",
  "legal moves only; the platform has the final word": "الانتقالات المسموح بها فقط؛ والكلمة الأخيرة للمنصة",
  "{status} is terminal. Nothing further can be done to this order; its history is the record.":
    "{status} حالة نهائية. لا يمكن إجراء أي شيء آخر على هذا الأمر؛ وسجله هو المرجع.",
  "Note for the transition log (required to put on hold)": "ملاحظة لسجل الانتقالات (مطلوبة للتعليق)",
  "Verification requires an identified person other than the one who completed the work.":
    "يتطلب التحقق شخصًا محددًا غير الذي أنجز العمل.",
  // prettier-ignore
  "Where the defect was raised with a photograph, completion needs an \"after\" photograph on the platform.":
    "إذا سُجّل العيب بصورة، فالإكمال يتطلب صورة «بعد» على المنصة.",

  /* ── inspections ── */
  Inspections: "الفحوصات",
  Scheduled: "مجدول",
  "{code} · inspections": "{code} · الفحوصات",
  "Rounds on record": "الجولات المسجّلة",
  "Rounds with failures": "جولات بها إخفاقات",
  "Failed items": "البنود الفاشلة",
  "Mean score, completed": "متوسط الدرجة، المكتملة",
  Checklist: "قائمة التحقق",
  "Any checklist": "أي قائمة تحقق",
  "{n} round|{n} rounds": "لا جولات|جولة واحدة|جولتان|{n} جولات|{n} جولة|{n} جولة",
  "No inspections match.": "لا توجد فحوصات مطابقة.",
  "The platform lists none at {code} — rounds are started from the field client.":
    "لا تسرد المنصة أي جولات في {code} — تبدأ الجولات من التطبيق الميداني.",
  Score: "الدرجة",
  Answers: "الإجابات",
  Failed: "فاشلة",
  "Captured on the field client without signal and synced later":
    "سُجّلت في التطبيق الميداني دون إشارة ثم زُامنت لاحقًا",
  "{pct}% covered": "مغطّاة بنسبة {pct}%",
  "not scored": "دون درجة",
  "{code} · inspection": "{code} · فحص",
  "{code} · inspection · {template}": "{code} · فحص · {template}",
  "← All inspections": "← جميع الفحوصات",
  Coverage: "التغطية",
  "{pct}% of the checklist": "{pct}% من قائمة التحقق",
  "{n} failed item|{n} failed items":
    "لا بنود فاشلة|بند فاشل واحد|بندان فاشلان|{n} بنود فاشلة|{n} بندًا فاشلًا|{n} بند فاشل",
  "No failed items": "لا بنود فاشلة",
  "each failure is a defect the pack raised; the work it produced is on the right":
    "كل إخفاق عيبٌ سجّلته الحزمة؛ والعمل الناتج عنه معروض في الجانب الآخر",
  "every item checked was within limits": "كل بند فُحص كان ضمن الحدود",
  Measurements: "القياسات",
  "items the pack judges by value": "بنود تحكم عليها الحزمة بالقيمة",
  "{n} other item|{n} other items": "لا بنود أخرى|بند آخر واحد|بندان آخران|{n} بنود أخرى|{n} بندًا آخر|{n} بند آخر",
  "passed, not applicable, or notes": "ناجحة، أو غير منطبقة، أو ملاحظات",
  Fold: "طيّ",
  Show: "عرض",
  "Folded — the record is kept; press Show to read every answer.": "مطويّة — السجل محفوظ؛ اضغط «عرض» لقراءة كل إجابة.",
  "Resulting work": "العمل الناتج",
  "work orders closing this round's defects": "أوامر العمل التي تغلق عيوب هذه الجولة",
  "work orders at the failed items' asset or zone (this platform does not list defect ids)":
    "أوامر العمل في أصل البنود الفاشلة أو منطقتها (هذه المنصة لا تسرد معرّفات العيوب)",
  "No work order is open at these assets or zones yet.": "لا يوجد أمر عمل مفتوح لهذه الأصول أو المناطق بعد.",
  "Nothing failed, so nothing was raised.": "لم يفشل شيء، فلم يُنشأ شيء.",
  Attributes: "السمات",
  pass: "ناجح",
  fail: "فاشل",
  na: "غير منطبق",
  value: "قيمة",
  "Defect raised by the pack's on_fail": "عيب سجّله on_fail في الحزمة",
  "defect {id}": "عيب {id}",
  "Skipped: {reason}": "تم التخطي: {reason}",
  "{n} photo|{n} photos": "لا صور|صورة واحدة|صورتان|{n} صور|{n} صورة|{n} صورة",

  /* ── alerts ── */
  "{code} · insight": "{code} · الرؤى",
  "All open": "كل المفتوحة",
  Reactive: "تفاعلية",
  "No open alerts at {code}. The rules ran and found nothing outside limits.":
    "لا توجد تنبيهات مفتوحة في {code}. نُفّذت القواعد ولم تجد شيئًا خارج الحدود.",
  "Select an alert to see why it fired.": "اختر تنبيهًا لترى سبب انطلاقه.",
  reactive: "تفاعلي",
  predictive: "تنبؤي",
  "raised {date}": "سُجّل {date}",
  "expected {date}": "متوقع {date}",
  "{pct}% confidence": "ثقة {pct}%",
  "Why did this fire?": "لماذا انطلق هذا؟",
  "New Work Order, pre-filled from this alert": "أمر عمل جديد، مُعبّأ مسبقًا من هذا التنبيه",
  Rule: "القاعدة",
  Class: "الفئة",
  Subject: "الموضوع",
  Reference: "المرجع",
  "none cited": "لا مرجع مذكور",
  Seen: "رُصد",
  "first {date}": "أول مرة {date}",
  Expected: "المتوقع",
  "confirmed by completed work": "تأكّد بعمل مكتمل",
  "refuted — the work was canceled": "دُحض — أُلغي العمل",
  "not yet confirmed or refuted": "لم يتأكد أو يُدحض بعد",
  "This rule carries a regulatory threshold. Its parameters were verified against the aerodrome's certification basis before it was enabled; the reference above is that basis.":
    "تحمل هذه القاعدة حدًا تنظيميًا. تم التحقق من معاملاتها مقابل أساس اعتماد المطار قبل تفعيلها؛ والمرجع أعلاه هو ذلك الأساس.",
  Expression: "التعبير",
  "Resolved values": "القيم المحسوبة",
  "The platform recorded no resolved values for this evaluation.": "لم تسجّل المنصة قيمًا محسوبة لهذا التقييم.",
  "Thresholds and parameters": "الحدود والمعاملات",
  "None.": "لا يوجد.",
  "No work order has been raised from this alert yet.": "لم يُنشأ أي أمر عمل من هذا التنبيه بعد.",

  /* ── dashboard ── */
  "{code} · overview": "{code} · نظرة عامة",
  "The state of the airport in one screen": "حالة المطار في شاشة واحدة",
  "Open work orders": "أوامر العمل المفتوحة",
  "Overdue against priority": "متأخرة عن أولويتها",
  "Awaiting verification": "بانتظار التحقق",
  "Open alerts": "التنبيهات المفتوحة",
  "each measure against a shown target, graded, with its source": "كل مقياس مقابل مستهدف ظاهر، مع تقديره ومصدره",
  "{pct}% of target across {n} measures": "{pct}% من المستهدف عبر {n} مقاييس",
  "{n} not computable — excluded, not counted as zero": "{n} غير قابلة للحساب — مستبعدة، ولا تُحسب صفرًا",
  "{n} with no declared target — shown, not graded": "{n} دون مستهدف معلن — معروضة دون تقدير",
  "{n} graded against proposed targets, not yet agreed": "{n} مقدّرة مقابل مستهدفات مقترحة لم يُتفق عليها بعد",
  "Needs attention": "تحتاج إلى اهتمام",
  "open work, highest priority and oldest first": "الأعمال المفتوحة، الأعلى أولوية والأقدم أولًا",
  "All work orders →": "جميع أوامر العمل ←",
  "No open work orders at {code}.": "لا توجد أوامر عمل مفتوحة في {code}.",
  "what the rules raised, most severe first": "ما أطلقته القواعد، الأشد خطورة أولًا",
  "Why did these fire? →": "لماذا انطلقت؟ ←",
  "No open alerts at {code}.": "لا توجد تنبيهات مفتوحة في {code}.",
  PREDICTIVE: "تنبؤي",
  REACTIVE: "تفاعلي",
  "Work by state": "الأعمال حسب الحالة",
  "the lifecycle, counted": "دورة الحياة، معدودة",

  /* ── KPI tile ── */
  "NOT COMPUTABLE": "غير قابل للحساب",
  "Grade {grade}": "التقدير {grade}",
  "Not graded": "دون تقدير",
  "The platform did not return a value.": "لم تُرجع المنصة قيمة.",
  "The pack declares no target for this measure": "لا تعلن الحزمة مستهدفًا لهذا المقياس",
  "no target declared · not graded": "لا مستهدف معلن · دون تقدير",
  "Target basis: {basis}": "أساس المستهدف: {basis}",
  "target {sign} {value} {unit}": "المستهدف {sign} {value} {unit}",
  "Proposed, not yet agreed — {basis}": "مقترح، لم يُتفق عليه بعد — {basis}",
  "Proposed, not yet agreed": "مقترح، لم يُتفق عليه بعد",
  PROPOSED: "مقترح",
  open: "مفتوحة",
  units: "وحدات",
  "% plan": "% من الخطة",
  "On-time departures within 15 min": "المغادرات في موعدها خلال 15 دقيقة",
  "Serious safety incidents open": "حوادث السلامة الجسيمة المفتوحة",
  "Security incidents and breaches open": "الحوادث والاختراقات الأمنية المفتوحة",
  "Passengers against plan": "الركاب مقابل الخطة",
  "Worst passenger queue": "أسوأ طابور للركاب",
  "Bags delivered on time": "الأمتعة المسلّمة في موعدها",
  "Runway availability": "جاهزية المدرج",
  "Major equipment out of service": "المعدات الرئيسية خارج الخدمة",
  "Weather disruption today": "تعطل الطقس اليوم",
  "Revenue against target": "الإيرادات مقابل المستهدف",
  "Predictive alert precision": "دقة التنبيهات التنبؤية",
  "Mean time to repair, P1": "متوسط وقت الإصلاح، P1",

  /* ── library catalogues (domain/library.ts) ── */
  "In review": "قيد المراجعة",
  Issued: "صادرة",
  Withdrawn: "مسحوبة",
  Superseded: "مستبدَلة",
  Rejected: "مرفوضة",
  Expired: "منتهية",
  "Expires within 30 days": "تنتهي خلال 30 يومًا",
  "Review overdue": "المراجعة متأخرة",
  "Review due within 30 days": "المراجعة مستحقة خلال 30 يومًا",
  "Submit for review": "إرسال للمراجعة",
  Issue: "إصدار",
  Reject: "رفض",
  "Withdraw revision": "سحب النسخة",
  Supersede: "استبدال",

  /* ── library ── */
  "{code} · library": "{code} · المكتبة",
  "{code} · library · {type}": "{code} · المكتبة · {type}",
  "Applies at {code}": "تنطبق في {code}",
  "{code} only": "{code} فقط",
  "Create a controlled document": "إنشاء وثيقة خاضعة للرقابة",
  "New document": "وثيقة جديدة",
  "Due within 30 days": "مستحقة خلال 30 يومًا",
  "Any type": "أي نوع",
  "Search title, reference, tags…": "ابحث بالعنوان أو المرجع أو الوسوم…",
  "{n} document|{n} documents": "لا وثائق|وثيقة واحدة|وثيقتان|{n} وثائق|{n} وثيقة|{n} وثيقة",
  "No documents match tagged to {code} alone — most controlled documents apply at every site.":
    "لا توجد وثائق مطابقة موسومة بـ {code} وحده — معظم الوثائق الخاضعة للرقابة تنطبق في كل موقع.",
  "No documents match.": "لا توجد وثائق مطابقة.",
  Document: "الوثيقة",
  Revision: "النسخة",
  "Review / expiry": "المراجعة / الانتهاء",
  Revs: "النسخ",
  "all sites": "جميع المواقع",
  "expires {date}": "تنتهي {date}",
  "review {date}": "مراجعة {date}",
  public: "عامة",
  internal: "داخلية",
  restricted: "مقيّدة",

  /* ── new document ── */
  "Creates the controlled item as a draft. Add its first revision — and the file — from the document page.":
    "يُنشئ البند الخاضع للرقابة كمسودة. أضف نسخته الأولى — والملف — من صفحة الوثيقة.",
  "Type (declared by the installed packs)": "النوع (تعلنه الحزم المثبّتة)",
  "Choose a type…": "اختر نوعًا…",
  "(uncontrolled)": "(غير خاضعة للرقابة)",
  "Requires approval before issue.": "تتطلب الاعتماد قبل الإصدار.",
  "Reviewed every {n} months.": "تُراجَع كل {n} شهرًا.",
  "Revisions carry an expiry date.": "تحمل النسخ تاريخ انتهاء.",
  "Retained {n} years.": "تُحفظ {n} سنة.",
  "Reference (the operator's own number)": "المرجع (رقم المشغّل الخاص)",
  "Applies at": "تنطبق في",
  "All sites (tenant-wide)": "جميع المواقع (على مستوى الجهة)",
  Classification: "التصنيف",
  "Restricted — fixed by the pack for this type.": "مقيّدة — تحددها الحزمة لهذا النوع.",
  "Pack default ({classification})": "افتراضي الحزمة ({classification})",
  "Pack default": "افتراضي الحزمة",
  Public: "عامة",
  Internal: "داخلية",
  Restricted: "مقيّدة",
  "Tags (comma-separated)": "الوسوم (مفصولة بفواصل)",
  Tags: "الوسوم",
  "runway, friction": "مدرج، احتكاك",
  "Create document": "إنشاء الوثيقة",

  /* ── one document ── */
  "← Library": "← المكتبة",
  "Draft the next revision": "صياغة النسخة التالية",
  "New revision": "نسخة جديدة",
  "Restricted — opening this document is recorded in the access log with your principal and address.":
    "مقيّدة — يُسجَّل فتح هذه الوثيقة في سجل الوصول مع هويتك وعنوانك.",
  "Withdrawn {date} — {reason}. Kept for the record; not to be used.":
    "سُحبت {date} — {reason}. محفوظة للسجل؛ لا تُستخدم.",
  "Withdrawn {date}. Kept for the record; not to be used.": "سُحبت {date}. محفوظة للسجل؛ لا تُستخدم.",
  "All sites": "جميع المواقع",
  "Current revision": "النسخة الحالية",
  "Review due": "موعد المراجعة",
  Expires: "تاريخ الانتهاء",
  "does not expire": "لا تنتهي",
  Controlled: "خاضعة للرقابة",
  "yes, approval required": "نعم، يلزم الاعتماد",
  yes: "نعم",
  no: "لا",
  Retention: "الاحتفاظ",
  "until {date}": "حتى {date}",
  "{n} years": "{n} سنة",
  Revisions: "النسخ",
  "every revision, newest first — superseded ones are the control, not clutter":
    "كل نسخة، الأحدث أولًا — النسخ المستبدَلة جزء من الرقابة وليست زوائد",
  "No revisions recorded.": "لا توجد نسخ مسجّلة.",
  Acknowledgements: "الإقرارات بالاطلاع",
  "{n} of {total} for the current issue": "{n} من {total} للإصدار الحالي",
  "You are required to read": "مطلوب منك قراءة",
  "Recording…": "جارٍ التسجيل…",
  "I have read this revision": "قرأت هذه النسخة",
  "The platform found no outstanding acknowledgement for you on this revision.":
    "لم تجد المنصة إقرارًا مستحقًا عليك لهذه النسخة.",
  "No acknowledgement required for this document.": "لا يلزم إقرار بالاطلاع لهذه الوثيقة.",
  outstanding: "مستحق",
  "Linked to": "مرتبطة بـ",
  "nothing yet": "لا شيء بعد",
  "Issued {date}": "صدرت {date}",
  "Created {date}": "أُنشئت {date}",
  "approved by {name}": "اعتمدها {name}",
  "Rejected: {reason}": "رُفضت: {reason}",
  "superseded {date}": "استُبدلت {date}",
  "Why it is rejected — recorded on the revision": "سبب الرفض — يُسجَّل على النسخة",
  "Rejection reason for {revision}": "سبب رفض {revision}",

  /* ── new revision ── */
  "New revision of {title}": "نسخة جديدة من {title}",
  "New revision — {title}": "نسخة جديدة — {title}",
  "Drafted as": "تُصاغ باسم",
  ", sequence {n}.": "، التسلسل {n}.",
  "This type requires approval: the draft goes to review, and someone other than its author approves it before it can be issued.":
    "يتطلب هذا النوع الاعتماد: تذهب المسودة إلى المراجعة، ويعتمدها شخص غير كاتبها قبل أن يمكن إصدارها.",
  "This type does not require approval: the draft can be issued directly.":
    "لا يتطلب هذا النوع الاعتماد: يمكن إصدار المسودة مباشرة.",
  "Review falls due {n} months after issue.": "تستحق المراجعة بعد {n} شهرًا من الإصدار.",
  "Revision label": "تسمية النسخة",
  "Change note — what changed and why": "ملاحظة التغيير — ما الذي تغيّر ولماذا",
  "Change note": "ملاحظة التغيير",
  "Issued on (leave blank to date it when issued)": "تاريخ الإصدار (اتركه فارغًا ليُؤرَّخ عند الإصدار)",
  "Issued on": "تاريخ الإصدار",
  "Expires on (required for this type)": "تاريخ الانتهاء (مطلوب لهذا النوع)",
  "Expires on": "تاريخ الانتهاء",
  "File (optional here; a revision without its file can be added later)":
    "الملف (اختياري هنا؛ يمكن إضافة ملف النسخة لاحقًا)",
  File: "الملف",
  "unknown type": "نوع غير معروف",
  "Drafting…": "جارٍ الصياغة…",
  "Draft revision": "صياغة النسخة",
  /* New Work Order pressed by someone whose role cannot create one */
  "You can't create work orders yet": "لا يمكنك إنشاء أوامر عمل بعد",
  "Your account can view work orders but can't create them. Ask an administrator to add the Supervisor or Technician role to your account in Administration › People.":
    "يمكن لحسابك عرض أوامر العمل لكن لا يمكنه إنشاؤها. اطلب من أحد المسؤولين إضافة دور «مشرف» أو «فني» إلى حسابك من الإدارة › الأشخاص.",
  "Open Administration": "افتح الإدارة",
  /* how a work order moves */
  "How a work order moves": "كيف يتقدم أمر العمل",
  "Reported. Waiting for approval.": "مُبلّغ عنه. بانتظار الموافقة.",
  "Approved. Waiting for a crew.": "تمت الموافقة. بانتظار طاقم.",
  "Assigned to a crew.": "أُسند إلى طاقم.",
  "The crew is working on it.": "الطاقم يعمل عليه.",
  "Work done. Waiting for a check.": "اكتمل العمل. بانتظار التحقق.",
  "Checked and closed.": "تم التحقق والإغلاق.",
  "Paused for parts, access or weather.": "متوقف مؤقتاً بسبب القطع أو الدخول أو الطقس.",
  "Stopped. Kept in the record.": "أُوقف. ويبقى في السجل.",
  "Anyone who can create work orders": "أي شخص يمكنه إنشاء أوامر العمل",
  "Supervisor or Administrator": "المشرف أو المسؤول",
  "Technician, from the phone app": "الفني، من تطبيق الهاتف",
  Technician: "الفني",
  "Supervisor or Accountable Manager": "المشرف أو المدير المسؤول",
  "Supervisor or Technician": "المشرف أو الفني",
  "Next: {step} — {who}.": "التالي: {step} — {who}.",
  "This order was canceled. Its history stays in the record.": "أُلغي هذا الأمر. ويبقى تاريخه في السجل.",
  "This order is closed. Its history stays in the record.": "هذا الأمر مغلق. ويبقى تاريخه في السجل.",
  "Your account can view this order but can't move it. Ask an administrator to add the Supervisor or Technician role to your account in Administration › People.":
    "يمكن لحسابك عرض هذا الأمر لكن لا يمكنه تحريكه. اطلب من أحد المسؤولين إضافة دور «مشرف» أو «فني» إلى حسابك من الإدارة › الأشخاص.",
  "Verify only if you didn't do the work yourself — a second person must check it.": "تحقق فقط إن لم تكن أنت من نفّذ العمل — يجب أن يتحقق شخص ثانٍ.",
  "A Supervisor or the Accountable Manager verifies this order — someone other than the person who completed the work.":
    "يتحقق من هذا الأمر مشرف أو المدير المسؤول — شخص غير الذي أكمل العمل.",
  /* work-order screens, reworded 2026-10-06 */
  "Parts reserved for this job, and where they are": "القطع المحجوزة لهذه المهمة، وأين وصلت",
  "Defects and tasks in this order": "العيوب والمهام في هذا الأمر",
  "Every status change, with who made it and when": "كل تغيير في الحالة، ومن قام به ومتى",
  "Time allowed to complete this order": "الوقت المسموح لإنجاز هذا الأمر",
  "Next step": "الخطوة التالية",
  "Only the allowed next steps are shown.": "تظهر الخطوات التالية المسموح بها فقط.",
  "Add a note (required when putting an order on hold)": "أضف ملاحظة (مطلوبة عند إيقاف الأمر مؤقتاً)",
  "This order is {status} and can't be changed.": "هذا الأمر في حالة «{status}» ولا يمكن تغييره.",
  "The SLA can't be changed once an order is {status}.": "لا يمكن تغيير مستوى الخدمة بعد أن يصبح الأمر «{status}».",
  "How many hours the crew has to complete this order.": "عدد الساعات المتاحة للطاقم لإنجاز هذا الأمر.",
  "Hours from when the order is created. Leave blank for no deadline.": "ساعات من وقت إنشاء الأمر. اتركه فارغاً إن لم يكن هناك موعد نهائي.",
  "All work orders and their deadlines. Filter them, see statistics, or print a report.": "كل أوامر العمل ومواعيدها النهائية. صفّها، واطّلع على الإحصاءات، أو اطبع تقريراً.",

  /* ── work orders: area, trade, contractor (domain/workOrderClass.ts) ── */
  Area: "المنطقة",
  Airside: "الجانب الجوي",
  Landscape: "تنسيق المواقع",
  Environmental: "البيئة",
  "Airfield lighting and navaids": "إنارة المطار والمساعدات الملاحية",
  "Runways, taxiways, aprons, lights, navaids": "المدارج والممرات والساحات والإنارة والمساعدات الملاحية",
  "Buildings, halls, gates, baggage, lifts": "المباني والصالات والبوابات والأمتعة والمصاعد",
  "Parking, roads, entrances, landscape, utilities": "المواقف والطرق والمداخل وتنسيق المواقع والمرافق",
  "Pavement, roads, buildings, markings": "الرصف والطرق والمباني والعلامات",
  "Power, lighting, substations": "الطاقة والإنارة ومحطات التحويل",
  "HVAC, lifts, escalators, baggage, doors": "التكييف والمصاعد والسلالم المتحركة والأمتعة والأبواب",
  "Alarms, sprinklers, suppression": "الإنذار والرشاشات والإطفاء",
  "Water, drainage, sewage, cooling": "المياه والتصريف والصرف الصحي والتبريد",
  "Irrigation, planting, grounds": "الري والزراعة والمساحات الخارجية",
  "Waste, noise, air, spills": "النفايات والضوضاء والهواء والانسكابات",
  "AGL, navaids, signs, MET": "إنارة المطار والمساعدات الملاحية واللوحات والأرصاد",
  "IT, FIDS, CCTV, access control": "تقنية المعلومات وشاشات الرحلات والكاميرات والتحكم بالدخول",
  "Anything else": "أي شيء آخر",
  "Area: {area}": "المنطقة: {area}",
  "Trade: {trade}": "التخصص: {trade}",
  "Contractor: {name}": "المقاول: {name}",
  "Own team": "الفريق الداخلي",
  "All areas": "كل المناطق",
  "Not set": "غير محدد",
  "Area not set": "المنطقة غير محددة",
  "Trade not set": "التخصص غير محدد",
  "All contractors": "كل المقاولين",
  "Choose area": "اختر المنطقة",
  "Choose trade": "اختر التخصص",
  "Leave blank if your own team does it": "اتركه فارغاً إن كان الفريق الداخلي سينفّذه",
  "(worked out)": "(مستنتج)",
  "You need the Supervisor or Technician role to change this.": "تحتاج إلى دور المشرف أو الفني لتغيير هذا.",
  "Contractor (blank = own team)": "المقاول (فارغ = الفريق الداخلي)",
  "By area": "حسب المنطقة",
  "By contractor": "حسب المقاول",
  Statistics: "الإحصاءات",
  "Search number, title, asset, contractor…": "ابحث بالرقم أو العنوان أو الأصل أو المقاول…",
  "Fewer filters": "مرشحات أقل",
  "More filters": "مرشحات أكثر",
  "SLA {state}": "مستوى الخدمة: {state}",
  "{n}d old": "عمره {n} يوم",

  /* ── work orders: where a dispatched order went (domain/workOrderDelivery.ts) ── */
  "Nobody told": "لم يُبلَّغ أحد",
  "Not delivered": "لم يصل",
  "No contractor or rule to tell. Set a contractor, or call them.": "لا يوجد مقاول أو قاعدة للإبلاغ. حدّد مقاولاً أو اتصل به.",
  "No message got through. Call the contractor.": "لم تصل أي رسالة. اتصل بالمقاول.",
  "Messages are on their way.": "الرسائل في طريقها.",
  "Delivered. Waiting for the contractor to confirm.": "وصلت. بانتظار تأكيد المقاول.",
  "The contractor confirmed they have it.": "أكّد المقاول استلامه.",
  "in the mobile app": "في تطبيق الجوال",
  "by the confirm link": "عبر رابط التأكيد",
  "by phone": "بالهاتف",
  "by email": "بالبريد الإلكتروني",
  "in person": "شخصياً",
  "Where it went": "إلى أين أُرسل",
  "Received {details} on {when}.": "استُلم {details} في {when}.",
  "Sent to {people} by {channels}.": "أُرسل إلى {people} عبر {channels}.",
  "{name} is not in the contact directory, so they were not told.": "{name} غير موجود في دليل جهات الاتصال، لذلك لم يُبلَّغ.",
  "Add them": "أضفه",
  "Name a contractor on this order, or add a rule in Who is told.": "حدّد مقاولاً لهذا الأمر، أو أضف قاعدة في «من يُبلَّغ».",
  "Sample: the contractor's app confirms by itself about 12 seconds after dispatch.": "بيانات تجريبية: يؤكد تطبيق المقاول الاستلام تلقائياً بعد نحو 12 ثانية من الإرسال.",
  "They confirmed another way?": "أكّدوا بطريقة أخرى؟",
  "How they confirmed": "طريقة التأكيد",
  "Who confirmed": "من أكّد",
  "Mark as received": "تسجيل الاستلام",

  /* ── work orders: closing from the phone, verification by photo ── */
  "The contractor can confirm, start and close the job, with a photo, from the link in their SMS or email.": "يستطيع المقاول تأكيد الاستلام وبدء العمل وإغلاقه مع صورة من الرابط في الرسالة النصية أو البريد.",
  "Open the contractor's phone (sample)": "افتح جوال المقاول (تجريبي)",
  "I received it": "تم الاستلام",
  "Photo of the finished work": "صورة العمل بعد الإنجاز",
  "Job done": "تم الإنجاز",
  "{date} by photo": "{date} بالصورة",
  "{before} before, {after} after.": "{before} قبل، {after} بعد.",
  "Verified automatically from the after photo.": "تم التحقق تلقائياً من صورة ما بعد الإنجاز.",
  "Verified by {name}.": "تحقق منه {name}.",
  "a supervisor": "مشرف",
  "Add an after photo and this order verifies itself. Or a supervisor or administrator can verify it.": "أضف صورة ما بعد الإنجاز ليتم التحقق تلقائياً، أو يتحقق منه مشرف أو مدير.",
  "Waiting for a supervisor or administrator to verify it.": "بانتظار تحقق مشرف أو مدير.",
  "At this site, an after photo verifies completed work automatically.": "في هذا الموقع، تتحقق صورة ما بعد الإنجاز من العمل المكتمل تلقائياً.",
  "At this site, a person verifies all completed work.": "في هذا الموقع، يتحقق شخص من كل عمل مكتمل.",
  "Turn off": "إيقاف",
  "Turn on": "تشغيل",
  "Add after photo": "أضف صورة بعد الإنجاز",
  "Write a note": "اكتب ملاحظة",
  "Every change and note, with who and when": "كل تغيير وملاحظة، مع من قام بها ومتى",
  "Photos and verification": "الصور والتحقق",
  "An after photo can verify finished work": "صورة ما بعد الإنجاز تتحقق من العمل",
};
export default ar;
